document.addEventListener('DOMContentLoaded', () => {
  
    let path = `${window.location.origin}/wp-content/themes/dreamclass2/dist/img/animation/`;
    
    const app = document.querySelector('.app');
    const data = JSON.parse(document.querySelector('#feature-list').innerHTML);
    const content = app.querySelector('.app-content');
    const appButtons = document.querySelectorAll('.app-buttons li input');
    
    let pointer;
    let timer = 0;
    const duration = 450;
  
    console.log(data.items.find((item) => {
      return item.id="classes"
    }));
  
    const fetchImage = (button) => {
        const image = button.dataset.file;
        const current = data.items.find(item => item.id === image);
        const className = current.class;
        const title = current.title;
        const list = current.items;
        document.querySelector('.app-description').innerHTML = '';
        let ul = `<ul class="checkboxes">`;
        list.forEach((item) => {
          ul += `<li>${item}</li>` ;
        });
        ul += `</ul>`;
        app.classList.remove('loaded');
        app.classList.add('loading');
        content.innerHTML = '';
  
        const img = new Image();
        img.src = `${path}${image}.png`;
        img.onload = () => {
          document.querySelector('.app-title').innerText = title;
          document.querySelector('.app-title').classList.forEach((cl) => {
            if(cl !== 'app-title'){
              document.querySelector('.app-title').classList.remove(cl);
            }
          });
          document.querySelector('.app-title').classList.add(className);
          console.log(ul);
          document.querySelector('.app-description').insertAdjacentHTML('beforeend', ul);
          app.classList.remove('loading');
          setTimeout(() => {
              content.appendChild(img);
              app.classList.add('loaded');
          }, 80);
        };
        /* fetch(`${path}${image}.png`).then((res) => {
            return res.text()
        }).then((data) => {
          console.log(data);
            content.innerHTML = data;
            //main.style.backgroundColor = color;
            document.querySelector('.app-title').innerText = title;
            document.querySelector('.app-title').classList.add(className);
            document.querySelector('.app-description').innerText = description;
            app.classList.remove('loading');
            setTimeout(() => {
                app.classList.add('loaded');
            }, 80)
        }); */
    }
  
    appButtons.forEach((item, i) => {
        if (item.checked) {
            fetchImage(item);
        }
        item.addEventListener('click', (e) => {
            fetchImage(e.target);
            timer = 0;
        })
    });
    
    function animate() {
        timer++;
        if (timer == duration) {
            appButtons.forEach((item, i) => {
                if (item.checked) {
                    pointer = i;
                }
            })
  
            const next = (pointer == appButtons.length - 1) ? 0 : pointer + 1;
            
            appButtons[next].checked = true;
            fetchImage(appButtons[next]);
            timer = 0;
        }
        //window.requestAnimationFrame(animate);
    }   
    
    animate();
  });